import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { companySchema } from '../schemas/company.schema';

/**
 * Get a Fleet Account's information by its alias or externalAccountId
 * @param alias Company Alias
 * @param externalAccountId Company External Account ID
 * @returns A Fleet Account's information
 */
export function getCompany(
  this: unknown,
  request: {
    alias?: string;
    externalAccountId?: string;
  }
) {
  if (
    typeof request.alias === 'undefined' &&
    typeof request.externalAccountId === 'undefined'
  ) {
    throw new ReferenceError(
      'Request must have at least alias or externalAccountId'
    );
  }

  const params = new URLSearchParams();
  if (typeof request.alias === 'string') {
    params.append('alias', request.alias);
  }
  if (typeof request.externalAccountId === 'string') {
    params.append('externalAccountId', request.externalAccountId);
  }

  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).companyUrl}?${params.toString()}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(companySchema));
}
